<ng-container>
  <div mat-dialog-title class="dialog-header">
    
    <div class="popup-header">
      {{
        data.applyMethod === applyMethodEnum.ViaWebsite
          ? ('text.PopupViaWebsite' | translate)
          : ('text.PopupViaCapture' | translate)
      }}
    </div>

    <div class="header-left">
      <mat-tab-group
        [(selectedIndex)]="data.selectedTab"
        class="header-tabs"
        mat-stretch-tabs
      >
        <mat-tab>
          <ng-template mat-tab-label>{{
            'label.SignIn' | translate
          }}</ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>{{
            'label.Registration' | translate
          }}</ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="close-icon">
      <svg-icon
        (click)="close()"
        src="/assets/icons/close-modal.svg"
        [svgStyle]="{
          display: 'flex',
          'justify-content': 'center',
          'align-items': 'center'
        }"
      ></svg-icon>
    </div>
  </div>

  <!-- Dialog Body -->
  <mat-dialog-content class="fancy-scroll">
    <!-- Content of active tab -->
    <ng-container [ngSwitch]="data.selectedTab">
      <ng-container *ngSwitchCase="0">
        <app-jobseeker-signin [isModalOpened]="true" (success)="onSuccess()">
        </app-jobseeker-signin>
      </ng-container>

      <ng-container *ngSwitchCase="1">
        <app-jobseeker-registration
          [isModalOpened]="true"
          (success)="onSuccess()"
        >
        </app-jobseeker-registration>
      </ng-container>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="mat-dialog-footer"></div>
  </mat-dialog-actions>
</ng-container>
